import(/* webpackMode: "eager", webpackExports: ["CalendarPage"] */ "/workspace/web/platform/calendar/CalendarPage.tsx");
